module.exports = __webpack_public_path__ + "img/user-big.976f9d17.svg";